import Component from "@glimmer/component";
import { service } from "@ember/service";
import { t } from "ember-intl";
import PageContent from "glesys-controlpanel/components/page-content";
import PageContentServiceIntro from "glesys-controlpanel/components/page-content/service-intro";
import GTabs from "glesys-controlpanel/components/g-tabs";
import GButtonLinkTo from "glesys-controlpanel/components/g-button/link-to";
import IconsPlus from "glesys-controlpanel/components/icons/plus";
import { and } from "ember-truth-helpers";
import canManage from "glesys-controlpanel/helpers/can-manage";

export default class BlockStorage extends Component {
  @service intl;
  @service router;

  get tabs() {
    return [{ name: this.intl.t("block-storage-volumes.tabs.volumes"), route: "block-storage.volumes.overview" }];
  }

  get showTabs() {
    return this.tabs.length > 1;
  }

  get hasVolumes() {
    return this.args.model.project?.blockStorageVolumes.length > 0;
  }

  get isOverview() {
    return this.router.currentRouteName === "block-storage.volumes.overview";
  }

  <template>
    {{#if this.isOverview}}
      <PageContent class="min-h-0 pb-0">
        <PageContentServiceIntro @title={{t "block-storage-volumes.page-title"}}>
          {{#if (and (canManage) this.hasVolumes)}}
            <GButtonLinkTo
              aria-label={{t "block-storage-volumes.create-volume-aria-label"}}
              data-test-block-storage-create-link
              @route="block-storage.volumes.create"
              @color="green"
            >
              <span class="flex items-center">
                <IconsPlus class="w-4 -ml-1 mr-1" />
                <span>{{t "button.create"}}</span>
              </span>
            </GButtonLinkTo>
          {{/if}}
        </PageContentServiceIntro>
        {{#if this.showTabs}}
          <GTabs @tabs={{this.tabs}} />
        {{/if}}
      </PageContent>
    {{/if}}
    {{outlet}}
  </template>
}
